import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

import { MOT_VALUATION_ROUTE } from 'Containers/app/checkerPages/Pages/CheckerRouter.utils';
import { CUSTOMER_HUB_VALUATION_ROUTE } from 'Containers/app/customerHub/CustomerHubHelpers';

export const MORE_FROM_MOTORWAY_TILES_PAGES = {
  ACCOUNT: 'account_page',
  HANDSHAKE: 'handshake_page',
  SALE_COMPLETE: 'sale_complete_page',
} as const;

type MoreFromMotorwayPage = typeof MORE_FROM_MOTORWAY_TILES_PAGES[keyof typeof MORE_FROM_MOTORWAY_TILES_PAGES];

type ReferProps = {
  category: MoreFromMotorwayPage;
  label: string;
};

type ReferPopupProps = {
  category: string;
  label: string;
};

export const MORE_FROM_MOTORWAY_EVENTS = {
  MOT_TILE_CLICKED: (category: MoreFromMotorwayPage) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category,
    name: 'more_from_motorway_mot_tile_clicked',
    url: MOT_VALUATION_ROUTE,
  }),
  REFER_COPY: ({ category, label }: ReferPopupProps) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category,
    label,
    name: 'more_from_motorway_referral_copy',
  }),
  REFER_POPUP: ({ category, label }: ReferPopupProps) => GENERIC_ANALYTICS_EVENTS.POPUP_LOAD_EVENT({
    category,
    label,
    name: 'more_from_motorway_referral_popup_appear',
  }),
  REFER_SHARE: ({ category, label }: ReferPopupProps) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category,
    label,
    name: 'more_from_motorway_referral_share',
  }),
  REFER_TILE_CLICKED: ({ category, label }: ReferProps) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category,
    label,
    name: 'more_from_motorway_refer_tile_clicked',
  }),
  TRACK_TILE_CLICKED: (category: MoreFromMotorwayPage) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category,
    name: 'more_from_motorway_track_tile_clicked',
    url: CUSTOMER_HUB_VALUATION_ROUTE,
  }),
};
